import {Brick, registerBrick} from 'olympe';
import PurchaseRequestDM from '../../models/cloudobjects/PurchaseRequestDM';
import {SOURCES} from '../constants';

/**
 * This brick processes SQL query results, categorizes purchase requests by source, and formats the data for
 * visualization. It outputs structured KPIs for charts, mapping sources to their respective counts.
 */
export default class ReadAndFormatKPIsResult extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} sQLQueryResult
     * @param {function()} forwardEvent
     * @param {function(Object)} setDataForChart
     */
    update($, [sQLQueryResult], [forwardEvent, setDataForChart]) {
        try {
            const result = JSON.parse(sQLQueryResult);
            const finalResult = {};

            result.forEach((item) => {
                switch (item[PurchaseRequestDM.DB_COLUMNS.source]) {
                case SOURCES.TSF:
                    finalResult['tsf'] = [{source: 'Technical Sourcing Form', number_of_pr: parseInt(item.count, 10)}];
                    break;
                case SOURCES.PUNCHOUT:
                    finalResult['punchout'] = [{source: 'PunchOut catalog', number_of_pr: parseInt(item.count, 10)}];
                    break;
                case SOURCES.MIXED:
                    finalResult['mix'] = [{source: 'PSL / Non-PSL', number_of_pr: parseInt(item.count, 10)}];
                    break;
                case SOURCES.PSL:
                    finalResult['psl'] = [{source: 'Preferred Supplier List', number_of_pr: parseInt(item.count, 10)}];
                    break;
                case SOURCES.PROMO:
                    finalResult['nsp'] = [{source: 'NSP', number_of_pr: parseInt(item.count, 10)}];
                    break;
                case SOURCES.DYN:
                    finalResult['dyn'] = [{source: 'Describe your needs', number_of_pr: parseInt(item.count, 10)}];
                    break;
                case SOURCES.CANDEX:
                    finalResult['candex'] = [{source: 'Candex', number_of_pr: parseInt(item.count, 10)}];
                    break;
                case SOURCES.AGENCY_MANIA:
                    finalResult['am'] = [{source: 'Agency Mania', number_of_pr: parseInt(item.count, 10)}];
                    break;
                default:
                    break;
                }
            });

            setDataForChart(finalResult);
            forwardEvent();
        } catch (e) {
            console.error(e);
            setDataForChart({});
            forwardEvent();
        }
    }
}

registerBrick('0198e5b4ccfaa1c1e022', ReadAndFormatKPIsResult);
